/* eslint-disable no-prototype-builtins */
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedDotcomConstants } from '../dotcom-constants';
import { TranslationService } from '@usana/ux/translations';
import { TranslationPdfService } from '@usana/ux/translations/pdf';
import * as FileSaver from 'file-saver';

@Injectable({ providedIn: 'root' })
export class TranslationMapperService {
    data;

    constructor(
        private translationService: TranslationService,
        private translationPdfService: TranslationPdfService,
    ) {}

    translateFromMap(src: string, map: any): Promise<any> {
        const listOfTags: string[] = this.mapToKeys(src, map);
        return new Promise<any>((resolve) => {
            if (listOfTags.length === 0) {
                resolve({});
            } else {
                this.translationService
                    .translateMultiAsPromise(SharedDotcomConstants.TRANSLATION_NAMESPACE, listOfTags)
                    .then((translations: Record<string, string>) => {
                        resolve(this.mapData(map, { translations }, listOfTags[0]));
                    });
            }
        });
    }

    convertDataFormat(origMap, data) {
        this.data = data;
        const map = JSON.parse(JSON.stringify(origMap));
        const prefix = Object.keys(data['translations'])[0].split('.')[0] + '.';
        if (Array.isArray(map)) {
            for (let i = 0; i < map.length; i++) {
                for (const item in map[i]) {
                    if (map[i].hasOwnProperty(item)) {
                        map[i][item] = this.lookupTag(prefix + i + '.' + item);
                    }
                }
            }
        } else {
            for (const item in map) {
                if (map.hasOwnProperty(item)) {
                    if (typeof map[item] === 'object') {
                        if (Array.isArray(map[item])) {
                            for (let i = 0; i < map[item].length; i++) {
                                for (const sub in map[item][i]) {
                                    if (map[item][i].hasOwnProperty(sub)) {
                                        if (typeof map[item][i][sub] === 'string') {
                                            map[item][i][sub] = this.lookupTag(prefix + map[item][i][sub]);
                                        } else {
                                            if (Array.isArray(map[item][i][sub])) {
                                                for (let x = 0; x < map[item][i][sub].length; x++) {
                                                    for (const xitem in map[item][i][sub][x]) {
                                                        if (map[item][i][sub][x].hasOwnProperty(xitem)) {
                                                            const value = this.lookupTag(`${prefix}${item}.${i}.${sub}.${x}.${xitem}`);
                                                            if (value) {
                                                                map[item][i][sub][x][xitem] = value;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            for (const sub in map[item]) {
                                if (map[item].hasOwnProperty(sub)) {
                                    map[item][sub] = this.lookupTag(prefix + item + '.' + sub);
                                }
                            }
                        }
                    } else {
                        map[item] = this.lookupTag(prefix + item);
                    }
                }
            }
        }
        return map;
    }

    createPdf(titleTag: string, bodyTags: string[], verification = true): Promise<object> {
        return this.translationPdfService
            .translateAsPdf(
                SharedDotcomConstants.TRANSLATION_NAMESPACE,
                titleTag,
                bodyTags,
                verification,
            )
            .then((response: HttpResponse<Blob>) => {
                const filename = response.headers.get('content-disposition').split('filename=')[1];
                FileSaver.saveAs(response.body, filename && filename.length > 0 ? filename : 'document.pdf');
                return null;
            });
    }

    lookupTag(tag) {
        if (tag !== this.data['translations'][tag]) {
            return this.data['translations'][tag];
        } else {
            return undefined;
        }
    }

    mapToKeys(filename, map): string[] {
        filename = this.srcToFileNameKey(filename);
        const listOfTags = [];
        const flattenedKeys = this.mapValues(this.flattenObject(map));
        flattenedKeys.forEach((key) => {
            listOfTags.push(`${filename}.${key}`);
        });
        return listOfTags;
    }

    srcToFileNameKey(src): string {
        return src;
    }

    private mapData(map, data, singleTag: string): any {
        if (map) {
            return this.convertDataFormat(map, data);
        } else {
            return data['translations'][singleTag];
        }
    }

    private flattenObject(ob) {
        const toReturn = {};
        for (const i in ob) {
            if (!ob.hasOwnProperty(i)) {
                continue;
            }
            if (typeof ob[i] === 'object') {
                const flatObject = this.flattenObject(ob[i]);
                for (const x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) {
                        continue;
                    }
                    toReturn[i + '.' + x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    private mapValues(map: any): any[] {
        return Object.keys(map).map((e) => map[e]);
    }
}
